module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: {
      //'primary': $store.getters['navigator/isPrimaryTheme'],
      //gray: $store.getters['navigator/isGrayTheme'],
      normal: _vm.$store.getters['navigator/isNormalTheme'],
      'app-audio': _vm.$store.state.player.isPlaying,
      'app-video': _vm.$store.getters['streamPlayer/hasFrame'],
      'app-header': _vm.$store.getters['navigator/hasHeader'],
      'app-footer': _vm.$store.getters['navigator/hasFooter'],
    },
    attrs: {
      "id": "app",
      "standalone": ""
    }
  }, [(_vm.showSidebar && !this.authPage && !this.welcomePage && !this.QRPage && !this.noSidebar) ? _c('sidebar') : _vm._e(), _vm._v(" "), _c('v-content', {
    class: {
      'bg-light': _vm.bgLight,
      'bg-grey': _vm.bgGrey,
      'bg-dark': _vm.bgDark,
      'bg-black': _vm.bgBlack,
      'bg-natural-grey': _vm.bgNaturalGrey
    }
  }, [(!_vm.onMobile && _vm.isAuthenticated) ? _c('span', [_c('app-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadValue !== 100),
      expression: "loadValue !== 100"
    }],
    ref: "appLoader",
    on: {
      "getLoadUpdate": _vm.getLoadUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "app-container",
    class: {
      'onMobile-container': _vm.onMobile,
      'onMobile-container-fullwidth': _vm.noSideSpace,
      'no-padding': _vm.noPadding,
      'no-margin': _vm.noMargin,
      'not-authenticated': !_vm.isAuthenticated,
      wrapFullHeight: _vm.wrapFullHeight
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.currentUser) ? _c('stream-player', {
    ref: "streamPlayer"
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.firstVisit) ? _c('earn-money-sticker') : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "multi-line": "",
      "top": "",
      "timeout": _vm.$store.state.error.timeout,
      "color": _vm.$store.state.error.color
    },
    model: {
      value: (_vm.showError),
      callback: function($$v) {
        _vm.showError = $$v
      },
      expression: "showError"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.error.errors[0]))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.dispatch('error/hideToast')
      }
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.show_login_dialog),
      callback: function($$v) {
        _vm.show_login_dialog = $$v
      },
      expression: "show_login_dialog"
    }
  }, [_c('login-dialog', {
    attrs: {
      "dismiss": _vm.closeLoginDialog
    }
  })], 1), _vm._v(" "), (_vm.onMobile) ? _c('v-dialog', {
    attrs: {
      "transition": "slide-up",
      "content-class": "no-border-radius",
      "fullscreen": ""
    },
    model: {
      value: (_vm.mobilePlayerActive),
      callback: function($$v) {
        _vm.mobilePlayerActive = $$v
      },
      expression: "mobilePlayerActive"
    }
  }, [_c('mobile-player', {
    attrs: {
      "isPlayerOpened": _vm.mobilePlayerActive
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.globalSMSactive) ? _c('SMS', {
    on: {
      "closeSMS": _vm.closeSMS
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1699
// module chunks = 180